import { api } from "@/utils/axios";

export const wageService = {
  wageTypeList(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_wage&opt=wage_type_list",
      body
    );
  },
  wageList(body) {
    return api.post("?c=Port&m=Web_Port&module=Set_wage&opt=wage_list", body);
  },
  expendWage(body) {
    return api.post("?c=Port&m=Web_Port&module=Set_wage&opt=expend_wage", body);
  },
};
